import type { GlobalState } from '../../../main/types/redux';
import type { DefaultLayoutState } from '../types';

export const getDefaultLayoutState = (state: GlobalState): DefaultLayoutState => state.layouts.defaultLayout;
